import { useGetAgreementsForQuestionCategoryQuery } from '@/hooks/qna/qna.gql.impl';
import { parseAgreements } from '@/parsers/qna';

const useAgreementsForAskQuestionCategory = () => {
  const { data } = useGetAgreementsForQuestionCategoryQuery(
    {},
    { select: parseAgreements },
  );
  return { data: data ?? [] };
};

export default useAgreementsForAskQuestionCategory;
